var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt012ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nvidia_color_diamond",
    transform: "translate(-500 -126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 174) rotate(-45)",
    fill: "#eeffd1",
    stroke: "#75b900",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789",
    transform: "translate(-2561 -1858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 40,
    height: 40,
    transform: "translate(3089 2012)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nvidia_logo",
    transform: "translate(3093.167 2019.734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M371,274.706a.573.573,0,0,1-.573.6v0a.6.6,0,1,1,.573-.6Zm.233,0a.808.808,0,1,0-.806.777.765.765,0,0,0,.806-.777m-.94.066h.086l.2.351h.22l-.221-.366a.2.2,0,0,0,.209-.217c0-.191-.132-.253-.356-.253h-.323v.836h.186v-.351m0-.141v-.2h.129c.07,0,.166.006.166.091s-.05.11-.133.11h-.163",
    transform: "translate(-337.899 -250.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M63.092,226.71l1.005,2.75H62.056Zm-1.076-1.071L59.7,231.508h1.636l.366-1.037h2.741l.347,1.037h1.776l-2.334-5.87Zm-4.65,5.871h1.659v-5.873h-1.66Zm-11.52-5.873-1.385,4.655-1.326-4.654H41.344l1.894,5.873h2.391l1.909-5.873Zm6.708,1.279h.713a1.671,1.671,0,1,1,0,3.341h-.713Zm-1.646-1.279v5.873H53.6c1.433,0,1.9-.238,2.407-.773a3.291,3.291,0,0,0,.589-2.1,3.486,3.486,0,0,0-.537-2.021c-.615-.82-1.5-.981-2.822-.981Zm-15.719-.008v5.881h1.673v-4.466h1.3a1.218,1.218,0,0,1,.942.328,2.2,2.2,0,0,1,.369,1.555v2.583h1.622v-3.249c0-2.319-1.478-2.632-2.925-2.632Zm13.049.008v5.873H49.9v-5.873Z",
    transform: "translate(-35.188 -207.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M59.193,38.237a8.92,8.92,0,0,1,6.4-3.475V33.619C60.869,34,56.781,38,56.781,38S59.1,44.689,65.589,45.3V44.087C60.824,43.488,59.193,38.237,59.193,38.237Zm6.4,3.435v1.112c-3.6-.642-4.6-4.385-4.6-4.385a7.786,7.786,0,0,1,4.6-2.226v1.22h-.006A3.456,3.456,0,0,0,62.9,38.62a4.8,4.8,0,0,0,2.69,3.052m0-10.16v2.107c.139-.011.277-.02.416-.024,5.366-.181,8.863,4.4,8.863,4.4s-4.016,4.883-8.2,4.883a6.164,6.164,0,0,1-1.08-.1v1.3a7.116,7.116,0,0,0,.9.058c3.893,0,6.709-1.988,9.435-4.342.452.362,2.3,1.243,2.683,1.628-2.592,2.17-8.634,3.92-12.059,3.92-.33,0-.647-.02-.959-.05v1.831h14.8V31.512Zm0,4.661V34.762c.137-.01.275-.017.416-.021,3.859-.121,6.391,3.316,6.391,3.316s-2.734,3.8-5.666,3.8a3.551,3.551,0,0,1-1.141-.182V37.393c1.5.182,1.8.845,2.708,2.351l2.009-1.694a5.319,5.319,0,0,0-3.938-1.923,7.23,7.23,0,0,0-.778.046",
    transform: "translate(-54.733 -31.512)",
    fill: "#77b900"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt012ColorDiamond);
export default __webpack_public_path__ + "static/media/PT012_color_diamond.19574e84fe584f4880b346295b930a8e.svg";
export { ForwardRef as ReactComponent };